import { RegistrationCPGRequest } from '../../models/registration-cpg/registration-cpg-request.interface';

export const mockRegistrationCPGRequest: RegistrationCPGRequest = {
  modelNumber: 'AB12345678',
};
